const urls = {
  getValidCourses: '/ppt-plugin/courses/valid',
} as const;

export default urls;
